var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 411.19 84.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-265.56 -287.13)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 263.04,
    y: 286.12,
    width: 95.59,
    height: 78.5
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "full_logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M308.88,315.91c.21-.92-.15-1.8-.81-1.95s-1.37.48-1.58,1.4.15,1.8.81,1.95,1.37-.48,1.58-1.4",
    transform: "translate(-265.56 -287.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.68,329.34a1.92,1.92,0,0,0,2.17-1.25,28.57,28.57,0,0,1,2.4-5,13.06,13.06,0,0,1-2.63-1.78.46.46,0,0,1,.36-.8,21.26,21.26,0,0,0,3.37.2h0a17,17,0,0,0-6.3-2.77.6.6,0,0,1-.37-.92,5.71,5.71,0,0,1,5.43-2.53,13.07,13.07,0,0,1,6-4.67,11.12,11.12,0,0,1,7.45-.55c1,.31,1.53.54,2,.73a13.16,13.16,0,0,0,8.26.47,1,1,0,0,1,1,1.42,13.11,13.11,0,0,1-7.69,5.85.81.81,0,0,0-.58.92,16.93,16.93,0,0,0,4.34,8.84,2.21,2.21,0,0,0,2.24.58,58.14,58.14,0,0,0,17-8.18c-2.31-6.14-4.5-12.31-6.53-18.69-2.45-7.71-10.6-14-18.17-14H299a7.94,7.94,0,0,0-6.8,5c-3.85,10.41-7.67,20.84-11.59,31.64a58,58,0,0,0,16.06,5.62",
    transform: "translate(-265.56 -287.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M301.06,355.73l0-.09a2.79,2.79,0,0,0-2-1.41,39.4,39.4,0,0,1-23.76-13.4.72.72,0,0,1,.65-1.17,39.44,39.44,0,0,0,4.22.33h0q-.85-.79-1.67-1.64c-.78-.82-1.51-1.67-2.2-2.53-3.31,9.13-6.73,18.6-10.34,28.61-1.23,3.42,1.1,7.1,4.51,7.1h35.31a39.12,39.12,0,0,0-4.66-15.8",
    transform: "translate(-265.56 -287.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.3,364.46c-3.48-9.69-7-18.68-10.49-27.43a57.92,57.92,0,0,1-6.4,6.25q2-.06,3.89-.31a.65.65,0,0,1,.45,1.18,58.08,58.08,0,0,1-19.87,8.58,1.4,1.4,0,0,0-.93,2,39.36,39.36,0,0,0,17.51,16.79h11.34c3.39,0,5.74-3.67,4.51-7.08",
    transform: "translate(-265.56 -287.13)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M471.78,312.82a2,2,0,0,1,2.07-1.79H489q1.79,0,1.24,1.79L473.16,362.5a2.19,2.19,0,0,1-2.21,1.79H453.84a2.35,2.35,0,0,1-2.48-1.79l-16.84-49.68q-.69-1.79,1-1.79h5.24q7.17,0,10.49,2.76t5.66,10.76l5.66,19.32Z",
    transform: "translate(-265.56 -287.13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M492.06,312.82a1.59,1.59,0,0,1,1.79-1.79H497q6.9,0,10.14,3.24t3.24,10.28V362.5q0,1.8-1.93,1.79H493.86a1.58,1.58,0,0,1-1.79-1.79Z",
    transform: "translate(-265.56 -287.13)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M535.81,362.5a1.59,1.59,0,0,1-1.79,1.79H519.39a1.58,1.58,0,0,1-1.79-1.79v-73q0-1.93,1.79-1.93h3.17q6.9,0,10.07,3.24t3.17,10.28v24.15l10.9-12.42a4.24,4.24,0,0,1,3.17-1.79H567a1,1,0,0,1,1,.62,1.1,1.1,0,0,1-.35,1.17l-16.15,17.94L569.2,362.5q.83,1.8-1,1.79H551.68a3.44,3.44,0,0,1-3.31-1.79l-9.25-17.8-3.31,3.59Z",
    transform: "translate(-265.56 -287.13)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M588.88,349.11a14,14,0,0,0,8.07,2.21q7,0,16.15-4a6.31,6.31,0,0,1,2.35-.69q1.66,0,1.66,2.07a14.88,14.88,0,0,1-4.28,10.21q-6.35,6.76-18.91,6.76-11.73,0-19-6.62-8.56-7.59-8.56-21.39,0-11.31,6.21-19,7.59-9.11,20.84-9.11,11.45,0,18.08,6.62t6.76,17.53q0,3-.28,6.9v.69q-.28,2.07-2.62,2.07H584.94a8.84,8.84,0,0,0,3.93,5.8m11.38-17.53a6.12,6.12,0,0,0-1.66-5.31,7.7,7.7,0,0,0-5.8-2.14,7.8,7.8,0,0,0-5.66,2.14,7.59,7.59,0,0,0-2.35,5.31Z",
    transform: "translate(-265.56 -287.13)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M629,361.4q-5.11-4.83-5.11-14.9v-57q0-1.93,1.79-1.93h3.17q6.9,0,10.07,3.24t3.17,10.28v43.33q0,5.66,4.42,5.66a9.37,9.37,0,0,0,5.52-2.35,3.16,3.16,0,0,1,1.79-.69q1.66,0,1.66,2.62a16.73,16.73,0,0,1-3,9.94q-4.28,5.8-12.42,5.8-6.9,0-11-4",
    transform: "translate(-265.56 -287.13)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M658.4,312.82a1.59,1.59,0,0,1,1.79-1.79h3.17q6.9,0,10.14,3.24t3.24,10.28V362.5q0,1.8-1.93,1.79H660.19a1.58,1.58,0,0,1-1.79-1.79Z",
    transform: "translate(-265.56 -287.13)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M496.29,305.27h-.88a2.78,2.78,0,0,1-2.78-2.78V290.35a2.78,2.78,0,0,1,2.78-2.78h12.64a2.78,2.78,0,0,1,2.78,2.78v.38a14.54,14.54,0,0,1-14.54,14.54",
    transform: "translate(-265.56 -287.13)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M662.06,305.27h-.88a2.78,2.78,0,0,1-2.78-2.78V290.35a2.78,2.78,0,0,1,2.78-2.78h12.64a2.78,2.78,0,0,1,2.78,2.78v.38a14.54,14.54,0,0,1-14.54,14.54",
    transform: "translate(-265.56 -287.13)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M442.74,362.5,420.24,300q-2.48-7.17-5.66-9.8t-9.11-2.62h-8.14a2.08,2.08,0,0,0-2.07,1.66L369.6,362.5q-.55,1.8,1.24,1.79h15.59q1.52,0,2.07-1.79l.38-1.12,2.51-7.55a42.45,42.45,0,0,0,28.49.29l2.84,8.38a2.83,2.83,0,0,0,2.76,1.79h15.87q1.79,0,1.38-1.79m-36.85-22.7a33.33,33.33,0,0,1-9.38-1.34l9.2-27.65,5.36,16.41,1.31,3.82h-.06l2.47,7.56a33.38,33.38,0,0,1-8.89,1.2",
    transform: "translate(-265.56 -287.13)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/full_logo.fcd94ca10be6eb839a6e3b641a89d865.svg";
export { ForwardRef as ReactComponent };